import styled, { css } from 'styled-components';
import { Icon } from '@synergy/icons';
// import CustomIcon from '../Icons/CustomIcon';

const Circle = styled.div`
    position: absolute;

    ${({ customPosition, size }) => {
        switch (customPosition) {
            case 'top-right':
                return css`
                    top: 0;
                    right: 0;
                `;
            case 'top-left':
                return css`
                    top: 0;
                    left: 0;
                    transform: rotate(-90deg);
                `;
            case 'bottom-right':
                return css`
                    bottom: 0;
                    right: 0;
                    transform: rotate(90deg);
                `;
            case 'bottom-left':
                return css`
                    bottom: 0;
                    left: 0;
                    transform: rotate(180deg);
                `;
            default:
                return css`
                    top: 0;
                    right: 0;
                `;
        }
    }}

    z-index: ${({ zIndex }) => (zIndex ? zIndex : -1)};
`;

const NovaCircle = ({ size, customColor, customPosition, zIndex }) => {
    return (
        <Circle size={size} customPosition={customPosition} zIndex={zIndex}>
            {/* <CustomIcon icon="NovaRing" customColor={customColor} width={size} height={size} /> */}
            <Icon iconsize='sm' icon='NovaRing' color={customColor}/>
        </Circle>
    );
};

export default NovaCircle;